export default {"src":"/_next/static/media/successMail.f84cce3a.svg","height":120,"width":120};